//Library Imports
import { Button, Dropdown, Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import { Link, useHistory } from "react-router-dom";

//Local Imports
import { CONTACTS_INNER_ANALYTICS, CONTACT_ANALYTICS, CONTENT_ANALYTICS } from "constants/types";
import Search from "./Search";
import ModalIndivisualItem from "modules/Manage/Shared/ModalIndivisualItem";
import ButtonSmall from "modules/Common/Components/ButtonSmall";
import DownAngle from "../../../assets/img/icons/DownAngle.svg";
import { createNewListWithIdsForAnalytics } from "modules/Campaigns/Audience/Lists/actions";
import { sortArticleContacts } from "./actions";
import { resetAnalyticsContent } from "../Contacts/action";

interface IContactEmailDropdown {
  emailsCount: number;
  items: any[];
  articleId: number;
  articleIndex: number;
  tab?: string;
  showPlus?: boolean;
}

const ContactEmailDropdown: React.FC<IContactEmailDropdown> = (props: IContactEmailDropdown) => {
  //Props
  const { items, emailsCount, articleId, tab, showPlus, articleIndex } = props;
  const history = useHistory();

  //Local States
  const [ellipsisState, setEllipsistate] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isCreateListClicked, setIsCreateListClicked] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState("NOSORT");

  //Redux States
  const searchedText = useSelector((state: RootState) => state.analyticsContent.emailSearchValue);
  const searchedData = useSelector((state: RootState) => state.analyticsContent.searchedData);
  const sortDirectionRedux = useSelector((state: RootState) => state.analyticsContent.sortDirection);
  const userName = useSelector(
    (state: RootState) => `${state.user.userData.first_name} ${state.user.userData.last_name}`
  );

  const setSearchValue = (searchValue: string) => {
    setSearchTerm(searchValue?.trim());
    store.dispatch({
      type: CONTENT_ANALYTICS.SET_SEARCH,
      payload: { searchValue: searchValue?.trim(), articleId: articleId, articleIndex: articleIndex },
    });
  };

  const redirectContactDetailUrl = (contactId: any) => {
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("contact_id")) {
      queryParams.delete("contact_id");
    }
    queryParams.append("contact_id", contactId);
    queryParams.append("page_source", "analytics-content");
    return `/analytics/contacts/dashboard/?${queryParams.toString()}`;
  };

  const beforeRedirectToContactDetails = () => {
    resetAnalyticsContent();
  };

  const createNewList = () => {
    let contactIds: any = [];
    contactIds = items.map((item: any) => item.contactId);
    const newListName = `${userName}, New List ${new Date().toUTCString()}`;
    createNewListWithIdsForAnalytics(newListName, contactIds).then((data: any) => {
      let queryParams = new URLSearchParams(window.location.search);
      if (queryParams.get("list_id")) {
        queryParams.delete("list_id");
      }

      queryParams.append("list_id", data.data.list_data.list_id);
      queryParams.append("page_source", "analytics-content");

      if (data.data.success === true) {
        history.push(`/audiences/lists/view?${queryParams.toString()}`);
      }
    });
  };

  useEffect(() => {
    if (!isVisible && sortDirection !== 'NOSORT') {
      handleSorting('sdefs'); // just reset the sorting
    }
  }, [isVisible]);

  const handleSorting = (_sortDirection: string) => {
    let direction = _sortDirection === "NOSORT" ? "ASC" : _sortDirection === "ASC" ? "DESC" : "NOSORT"
    setSortDirection(direction);
    sortArticleContacts(
      direction,
      articleId,
      articleIndex
    )
  }


  const menu = () => (
    <Menu>
      <div className="email-container content-email-container">
        <div className="sub-header">
          <Search
            placeholder="Search"
            handleSearch={setSearchValue}
            reset={searchedText}
            isVisible={isVisible}
          />
          <div
            className="sorting-clicks"
            onClick={() => handleSorting(sortDirection)}
          >
            Clicks
            <span className="sort-direction">
              {sortDirection === "ASC" && (
                <span className="sort_asc">
                  <img src={DownAngle} alt="Sort Asc" />
                </span>
              )}
              {sortDirection === "DESC" && (
                <span className="sort_desc">
                  <img src={DownAngle} alt="Sort Desc" />
                </span>
              )}
              {sortDirection === "NOSORT" && (
                <>
                  <span className="sort_asc">
                    <img src={DownAngle} alt="Sort Asc" />
                  </span>
                  <span className="sort_desc">
                    <img src={DownAngle} alt="Sort Desc" />
                  </span>
                </>
              )}
            </span>
          </div>
        </div>

        <div className="email-list ">
          {searchTerm !== "" && searchedData.length <= 0 ? (
            <div style={{ textAlign: "center" }}>No data found.</div>
          ) : searchTerm !== "" && Object.keys(searchedData).length > 0 ? (
            Object.values(searchedData).map((item: any) => (
              <Tooltip placement="top" title={ellipsisState ? item.contactEmail : undefined}>
                <ModalIndivisualItem
                  person_name={item.contactName}
                  email={item.contactEmail}
                  color={item.contactColor ?? "#d9d9d9"} // if no color set default  #d9d9d9
                  imgUrl={item.contactImage}
                  clickCount={`${item.clickCount}`}
                  showCheckbox={false}
                  imageRedirectURL={`${redirectContactDetailUrl(item.contactId)}`}
                  beforeRedirect={beforeRedirectToContactDetails}
                />
              </Tooltip>
            ))
          ) : (
            Object.values(items).map((item: any) => (
              <Tooltip placement="top" title={item.contactEmail}>
                <ModalIndivisualItem
                  person_name={item.contactName}
                  email={item.contactEmail}
                  clickCount={`${item.clickCount}`}
                  color={item.contactColor ?? "#d9d9d9"} // if no color set default  #d9d9d9
                  imgUrl={item.contactImage}
                  showCheckbox={false}
                  imageRedirectURL={`${redirectContactDetailUrl(item.contactId)}`}
                  beforeRedirect={beforeRedirectToContactDetails}
                />
              </Tooltip>
            ))
          )}
        </div>

        <div className={`footer-content-email d-flex justify-content-center py-2 `}>
          <ButtonSmall
            value="Create a list"
            onClick={() => {
              setIsCreateListClicked(true);
              createNewList();
            }}
            className={`${isCreateListClicked ? "disabled" : ""}`}
          />
        </div>
      </div>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      placement="bottomLeft"
      trigger="click"
      overlayClassName="dropdown-checked-by"
      onVisibleChange={(visible: boolean) => {
        setIsVisible(visible && emailsCount > 0);
      }}
      visible={isVisible}
      getPopupContainer={() =>
        document.querySelectorAll("#scrollableDiv .infinite-scroll-component")[0] as HTMLElement
      }
    >
      <Button className="user-count" data-clicked="clicked-by-dropdown">
        {`${emailsCount}${emailsCount > 0 && showPlus ? "+" : ""}`}
        {/* <span className="ant-select-arrow" unselectable="on" aria-hidden="true" style={{ userSelect: "none" }}> */}
        {/* <span role="img" aria-label="down" className="anticon anticon-down ant-select-suffix">
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="down"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path>
            </svg>
          </span> */}
        {/* </span> */}
      </Button>
    </Dropdown>
  );
};
ContactEmailDropdown.defaultProps = {
  showPlus: true,
};
export default ContactEmailDropdown;
